export default __webpack_public_path__ + "a6bdbf75536ae8fc49de05059422057b.jpg";